<template>
  <div id="osList">

    <filtros-servicos>

    </filtros-servicos>

    <div class="table-responsive">
      <table class="table table-striped tabelaInventario">
        <thead>
          <tr>
            <th scope="col">{{ $t('AÇÃO') }}</th>
            <!-- <th scope="col">{{ $t('CD_PNEU') }}</th> -->
            <th scope="col">{{ $t('FOGO') }}</th>
            <th scope="col">{{ $t('FILIAL') }}</th>
            <th scope="col">{{ $t('MARCA') }}</th>
            <th scope="col">{{ $t('MEDIDA') }}</th>
            <th scope="col">{{ $t('MODELO') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(placa, index) in placas.data" :key="index">
            <th scope="row">
              <b-button class="btn" v-b-modal.modalDescarte @click="setPneu(placa)">
                <i class="fa fa-pen"></i>
              </b-button>
            </th>
            <!-- <td>{{ placa.cd_pneu }}</td> -->
            <td>{{ placa.nr_fogo }}</td>
            <td>{{ placa.ds_filial }}</td>
            <td>{{ placa.ds_marca }}</td>
            <td>{{ placa.ds_medida }}</td>
            <td>{{ placa.ds_modelo }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 d-flex justify-content-center mt-2 mb-5">
      <pagination-movimentacao position="bottom"></pagination-movimentacao>
    </div>
    <modal-servico ref="childAfericao" :pneu="this.pneu"></modal-servico>
  </div>
</template>

<script>
import FiltrosServicos from '@/components/FiltrosServicos'
import ModalServico from '@/components/Borracharia/ModalServico'
import paginationMovimentacao from './paginationMovimentacao.vue'

export default {
  components: {
    FiltrosServicos,
    ModalServico,
    paginationMovimentacao
  },

  data() {
    return {
      placa: '',
      showTrocaPneu: false,
      pneu: ''
    }
  },

  computed: {
    placas() {
      if (!this.$store.getters['borracharia/page'](this.paginacao.currentPage)) {
        this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
      }

      return this.$store.getters['borracharia/page'](this.paginacao.currentPage)

    },
    paginacao() {
      return this.$store.getters['borracharia/pagination']
    },
  },

  mounted() {
    this.$store.dispatch('borracharia/fetchPlacasDescartes', {})
    this.$store.dispatch('borracharia/getFromDescarte')
    this.$store.dispatch('borracharia/getFiltros')

  },

  methods: {
    setPneu(pneu){
      this.pneu = pneu
    }
    // getFromDescarte(placa) {
    //   this.$store.dispatch('borracharia/getFromDescarte', { data: placa }).then(() => {
    //     // this.$refs.childAfericao.gerarCaminhao()
    //     // this.$refs.childAfericao.adicionarAcao()
    //     // this.$refs.childAfericao.adicionarClassePneu()
    //     // this.placa = placa
    //   })
    // },
  }
}
</script>

<style lang="scss">
.icon--custom {
  top: 50px;
}

// .backgroundWarning {

// }

.backgroundError {
  background: linear-gradient(45deg, #992d2d, #fd6565);
  color: #fff;
}

// .content {
//   padding: 0 0;
// }
// .container-fluid{
//   padding-right: 0px;
//   padding-left: 0px;
// }</style>